import React, { useState, useEffect } from 'react'
import { collection, getDocs, query, where, Timestamp, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { useMediaQuery } from '@mui/material';



//theme
const themeColor = "#474aee"

const TipsWeek = () => {
  const isPhone = useMediaQuery('(max-width:600px)');
  const [documentsAddedThisWeek, setDocumentsAddedThisWeek] = useState(0);

  useEffect(() => {
    const collectionRef = collection(db, 'tips');
    const fetchDocumentsAddedThisWeek = () => {
      const today = new Date();
      const oneWeekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      const q = query(collectionRef, where('date', '>=', Timestamp.fromMillis(oneWeekAgo.getTime())));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        setDocumentsAddedThisWeek(snapshot.size);
      });
      return unsubscribe;
    };
    const unsubscribe = fetchDocumentsAddedThisWeek();
    // Cleanup function to unsubscribe from the snapshot listener
    return () => {
      unsubscribe();
    };
  }, []);
  //console.log(isPhone)

  return (
    <Card sx={isPhone ? { maxWidth: 300, minWidth: 300, } : { maxWidth: 345, minWidth: 300, }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: themeColor }} aria-label="recipe">
            <AnnouncementIcon />
          </Avatar>
        }
      />

      {
        isPhone ?
          <CardContent>
            <Typography variant="h5">
              Innsendt siste 7 dagene : {documentsAddedThisWeek}
            </Typography>
          </CardContent>
          :
          <CardContent>
            <Typography variant="h5">
              Innsendt siste 7 dagenes
            </Typography>
            <Typography variant="h5">
              {documentsAddedThisWeek}
            </Typography>
          </CardContent>
      }
    </Card>

  )
}

export default TipsWeek